// extracted by mini-css-extract-plugin
export default {"image":"Photo_image__krFEu","yesorno":"Photo_yesorno__PqSOX"};